import Prism from 'prismjs';

const {
  Token,
  highlight,
  highlightAll,
  highlightAllUnder,
  highlightElement,
  hooks,
  languages,
  plugins,
  tokenize,
  util,
} = Prism;

export {
  highlight,
  highlightAll,
  highlightAllUnder,
  highlightElement,
  hooks,
  languages,
  plugins,
  Token,
  tokenize,
  util,
};

export default Prism;